    //
    import { mapActions } from "vuex"

    //
    export default {
        name: "index-view",
        methods: {

            //
            ...mapActions("MenuesModule", {
                setTitleTopBar: "setTitleTopBar",
            }),
        },
        created (){
            this.setTitleTopBar( "Bienvenido" )
        },
    }